const reducer = (state, { type, payload }) => {
	switch (type) {
		case "SET_STATE_DATA":
			return {
				...state,
				...payload,
			}
		case "LOADED":
			return {
				...state,
				message:undefined,
				loading: false
			}
		case "LOAD_FAILED":
			return {
				...state,
				message: payload,
				loading: false,
			}
		case "IN_LOADING":
			return {
				...state,
				loading: true
			}
		default:
			return state
	}
}

export default reducer;